var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.344,
    height: 70.087,
    viewBox: "0 0 57.344 70.087",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37878",
    "data-name": "Group 37878",
    transform: "translate(-183 -204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_9004737_file_document_paper_page_icon",
    "data-name": "9004737_file_document_paper_page_icon",
    transform: "translate(183 204)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27727",
    "data-name": "Path 27727",
    d: "M50.786,71.087H12.557A9.557,9.557,0,0,1,3,61.53V10.557A9.557,9.557,0,0,1,12.557,1H29.579a12.743,12.743,0,0,1,9.013,3.734L56.61,22.752a12.743,12.743,0,0,1,3.734,9.013V61.53A9.557,9.557,0,0,1,50.786,71.087Z",
    transform: "translate(-3 -1)",
    fill: "#fef1e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27730",
    "data-name": "Path 27730",
    d: "M37.339,25.7H22.557A9.557,9.557,0,0,1,13,16.142V1.36a13.026,13.026,0,0,1,3.727,2.58L34.759,21.972a13.027,13.027,0,0,1,2.58,3.727Z",
    transform: "translate(18.858 -0.213)",
    fill: "#f5d9c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37877",
    "data-name": "Group 37877",
    transform: "translate(205.907 236.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27732",
    "data-name": "Path 27732",
    d: "M8,8.816C8,6.709,9.993,5,12.453,5h1.272c2.459,0,4.453,1.709,4.453,3.816a3.816,3.816,0,0,1-2.544,3.816c-1.6.752-2.641,2.826-2.544,5.089",
    transform: "translate(-8 -5)",
    fill: "none",
    stroke: "#ee7e3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_455",
    "data-name": "Line 455",
    y2: 0.013,
    transform: "translate(5.089 17.81)",
    fill: "none",
    stroke: "#ee7e3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.d3554e338577ff2f75e4fc56a8bf4eff.svg";
export { ForwardRef as ReactComponent };